import React from "react";
import { Routes, Route, useNavigate, useLocation, useParams } from "react-router-dom";
import { BusinessesLoadingDialog } from "./businesses-loading-dialog/BusinessesLoadingDialog";
import { BusinessesCard } from "./BusinessesCard";
import { BusinessesUIProvider } from "./BusinessesUIContext";
import { BusinessDeleteDialog } from "./business-delete-dialog/BusinessDeleteDialog";
import { BusinessesDeleteDialog } from "./businesses-delete-dialog/BusinessesDeleteDialog";
import { BusinessesFetchDialog } from "./businesses-fetch-dialog/BusinessesFetchDialog";
import { BusinessesUpdateStatusDialog } from "./businesses-update-status-dialog/BusinessesUpdateStatusDialog";

function BusinessesDeleteDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesDeleteDialog show={location.pathname === "/business/pending/deleteBusinesses"} onHide={() => navigate("/business/pending")} />;
}
function BusinessDeleteDialogRoute() {
  const navigate = useNavigate();
  const { id } = useParams();
  return <BusinessDeleteDialog show id={id} onHide={() => navigate("/business/pending")} />;
}
function BusinessesFetchDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesFetchDialog show={location.pathname === "/business/pending/fetch"} onHide={() => navigate("/business/pending")} />;
}
function BusinessesUpdateStatusDialogRoute() {
  const location = useLocation();
  const navigate = useNavigate();
  return <BusinessesUpdateStatusDialog show={location.pathname === "/business/pending/updateStatus"} onHide={() => navigate("/business/pending")} />;
}

export function BusinessesPagePending() {
  const navigate = useNavigate();
  const businessesUIEvents = {
    newBusinessButtonClick: () => navigate("/business/new"),
    openEditBusinessPage: (id) => navigate(`/business/${id}/edit`),
    openDeleteBusinessDialog: (id) => navigate(`/business/pending/${id}/delete`),
    openDeleteBusinessesDialog: () => navigate("/business/pending/deleteBusinesses"),
    openFetchBusinessesDialog: () => navigate("/business/pending/fetch"),
    openUpdateBusinessesStatusDialog: () => navigate("/business/pending/updateStatus"),
  };

  return (
    <BusinessesUIProvider businessesUIEvents={businessesUIEvents}>
      <BusinessesLoadingDialog />
      <Routes>
        <Route path="deleteBusinesses" element={<BusinessesDeleteDialogRoute />} />
        <Route path=":id/delete" element={<BusinessDeleteDialogRoute />} />
        <Route path="fetch" element={<BusinessesFetchDialogRoute />} />
        <Route path="updateStatus" element={<BusinessesUpdateStatusDialogRoute />} />
      </Routes>
      <BusinessesCard />
    </BusinessesUIProvider>
  );
}
